import { PageLayout } from "../components/PageLayout";
import { Reveal } from "../components/Reveal";
import { QuoteForm } from "../components/QuoteForm";

export const Angebot = () => (
    <PageLayout>
        <section className="pt-28 lg:pt-36 pb-6 px-4 sm:px-6 lg:px-12 max-w-3xl mx-auto text-center">
            <Reveal>
                <p className="font-mono text-xs uppercase tracking-[0.25em] text-leaf font-semibold mb-4">
                    Angebot &amp; Kontakt
                </p>
                <h1 className="font-display font-bold tracking-tight text-ink text-3xl sm:text-4xl lg:text-5xl leading-[1.1]">
                    Kostenloses Angebot anfragen.
                </h1>
                <p className="mt-6 text-base sm:text-lg text-shade leading-relaxed">
                    Kurz beschreiben, worum es geht – optional mit Foto. Sie erhalten ein
                    unverbindliches Festpreis-Angebot, in der Regel innerhalb von 24 Stunden.
                </p>
            </Reveal>
        </section>
        <QuoteForm eyebrowNum="01" eyebrowLabel="Ihre Anfrage" />
    </PageLayout>
);
